export const createClientOperationId = prefix => (
	`${prefix}-${Date.now().toString(36)}-` +
	`${Math.random().toString(36).slice(2)}${Math.random().toString(36).slice(2)}`
);

export default createClientOperationId;
